import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as pluginDataLabels from 'chart.js';
import { Label } from 'ng2-charts';
import * as moment from 'moment'
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { environment } from '../../../../../environments/environment';
import { common_environment } from '../../../../../environments/common.environment';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ReportService } from 'src/app/services/report/report.service';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
declare var $: any;
@Component({
  selector: 'app-sales-report',
  templateUrl: './sales-report.component.html',
  styleUrls: ['./sales-report.component.scss']
})
export class SalesReportComponent implements OnInit {

  myDateValue: Date;
  selectedStartDate: string;

  public selectorActive: number = 1;
  public tabActive: number = 1;
  public acceptingOrders: boolean = false;
  public isDataLoaded: boolean = false
  public currency = `${environment.currency}`;
  public currency_logo = `${environment.currency_logo}`;
  //tile config
  dashboardTileTypeTotal: string;
  dashboardTileTypeAccepted: string;
  dashboardTileTypeCompleted: string;
  dashboardTileTypeReady: string;
  dashboardTileTypeDeclined: string;
  dashboardTileTypeCanceled: string;
  bestSellingProducts: any
  grossRevenue: number;
  netRevenue: number;
  cancelledRevenue: number;
  grossRevenuePercentage: number;
  netRevenuePercentage: number;
  cancelledRevenuePercentage: number;
  startDate: any;
  endDate: any;
  selectedFranchise: any;
  isSummaryShow: boolean = true;

  franchises: any;
  shops: any;
  selectedOutletCode: any;
  loggedUserRole: any;

  selectedFilterFranchise: any = null;
  selectedFilterShop: any = null;

  outletCodes: any = [];
  fromDashBoard: boolean = false;
  counterVar = 0;
  isFilterClicked = false;
  integrationsList = [];

  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
      },
    }
  };


  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      xAxes: [{}],
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];

  public barChartData: ChartDataSets[] = [
    { data: [], label: 'Sales', backgroundColor: '#2D5697' },

  ];

  public revenueBarChartLabels: Label[] = [];
  public revenueBarChartType: ChartType = 'bar';
  public revenueBarChartLegend = true;
  public revenueBarChartPlugins = [pluginDataLabels];

  public revenueBarChartData: ChartDataSets[] = [
  ];


  colorTheme = 'theme-dark-blue';

  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private reportService: ReportService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private deliveryService: DeliveryPlatformService,
    private adminService: AdminService,

  ) {
  }

  ngOnInit() {

    this.getCurrentUser();
    this.getIntegrations();
    this.bsConfig = Object.assign({}, { containerClass: this.colorTheme });
    var today = moment().format('YYYY-MM-DD');


    this.myDateValue = new Date();
    this.dashboardTileTypeTotal = 'total'
    this.dashboardTileTypeAccepted = 'accepted';
    this.dashboardTileTypeCompleted = 'completed';
    this.dashboardTileTypeReady = 'ready';
    this.dashboardTileTypeDeclined = 'declined';
    this.dashboardTileTypeCanceled = 'canceled';
    this.acceptingOrders = this.getRestaurantStatus();

    this.route.params.subscribe(params => {

      this.selectedFilterFranchise = params.franchise;
      this.selectedFilterShop = params.shop;
      this.selectedOutletCode = params.shop_code;
      console.log(params)
    }
    );

    this.getAllFranchises();
    this.getTenants();

    var today = moment().format('YYYY-MM-DD');
    this.startDate = today;
    this.endDate = today;

  }

  filterForm: FormGroup = new FormGroup({
    franchise: new FormControl(''),
    shop: new FormControl(''),
  })

  dateForm: FormGroup = new FormGroup({
    date: new FormControl(''),
  })

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }


  public todayPressed() {
    var now = moment();
    var last7dasy = moment().subtract(7, 'days');
  }

  selectorPressed(selectorId) {
    this.dateForm.reset();
    var today = moment().format('YYYY-MM-DD');
    this.selectorActive = selectorId;
    switch (selectorId) {
      case 1: {
        this.isDataLoaded = false;
        this.getDashbaordData(today, today)
        this.startDate = today;
        this.endDate = today;
      }
        break;
      case 2: {
        this.isDataLoaded = false;
        var yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.getDashbaordData(yesterday, yesterday)
        this.startDate = yesterday;
        this.endDate = yesterday;
      }
        break;
      case 3: {
        this.isDataLoaded = false;
        var last7dasy = moment().subtract(7, 'days').format('YYYY-MM-DD');
        this.getDashbaordData(last7dasy, today)
        this.startDate = last7dasy;
        this.endDate = today;
      }
        break;
      case 4: {
        this.isDataLoaded = false;
        var lastMonthStartDay = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        var lastMonthEndDay = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        this.getDashbaordData(lastMonthStartDay, lastMonthEndDay)
        this.startDate = lastMonthStartDay;
        this.endDate = lastMonthEndDay;
      }
        break;

      default: console.log('Not Valid')
    }
  }

  setProductData(data) {
    var labels: string[] = [];
    var values: number[] = [];
    data.forEach(element => {
      labels.push(element.item_name);
      values.push(element.total);
    });
  }


  getIntegrations() {
    this.deliveryService.getIntegrations(this.selectedFilterFranchise, this.selectedFilterShop).subscribe(res => {
      res.data.forEach(e => {
        this.integrationsList[e.id] = e.primary_color;

        if (this.selectedFilterFranchise && this.selectedOutletCode != "undefined") {
          this.outletCodes.push(this.selectedOutletCode);
          this.getDashbaordData(this.startDate, this.endDate);
          this.fromDashBoard = true;
        } else {
          this.outletCodes = this.authService.getLoggedUser().user_outlets;
          this.getDashbaordData(this.startDate, this.endDate);
        }

        $('.selectpicker').selectpicker('refresh');
      })

    })
  }

  setBarChartData(data) {

    data.forEach(element => {

      if (this.integrationsList[element.delivery_platform_id] != null) {
        element.backgroundColor = this.integrationsList[element.delivery_platform_id];
      }
    });

    return data;
  }


  getDashbaordData(from_date, to_date) {

    this.reportService.getDashboardData({
      to_date: to_date,
      from_date: from_date,
      tenant_code: environment.x_tenant_code,
      outlet_code: this.outletCodes
    })
      .subscribe({
        next: (res) => {
          var barChatLabels = res.data.platform_revenue_stat.labels
          var barChartData = this.setBarChartData(res.data.platform_revenue_stat.stats)
          this.barChartLabels = barChatLabels;

          if (barChartData.length > 0) {
            this.barChartData = barChartData;
          } else {
            this.barChartData = [
              { data: [], label: 'Sales', backgroundColor: '#2D5697' },

            ];
          }

          this.revenueBarChartLabels = barChatLabels;
          this.revenueBarChartData = res.data.revenue_stat;
          this.bestSellingProducts = res.data.best_selling_product_list
          this.setProductData(res.data.all_products);
          this.grossRevenue = res.data.grossRevenue;
          this.netRevenue = res.data.netRevenue;
          this.cancelledRevenue = res.data.cancelledRevenue;
          this.grossRevenuePercentage = res.data.grossRevenuePercentage;
          this.netRevenuePercentage = res.data.netRevenuePercentage;
          this.cancelledRevenuePercentage = res.data.cancelledRevenuePercentage;
          this.isDataLoaded = true;
        },
        error: (error) => { }
      });

  }

  updateMyDate(newDate) {
    if (newDate) {
      this.isDataLoaded = false;
      this.selectorActive = 5;
      var formatFromDate = moment(newDate[0]).format('YYYY-MM-DD');
      var formatToDate = moment(newDate[1]).format('YYYY-MM-DD');
      this.getDashbaordData(formatFromDate, formatToDate);
    }
  }

  onclickTab(tabId) {
    this.tabActive = tabId;
    this.router.navigate([`/home/sales-report`]);
  }

  getRestaurantStatus() {
    if (localStorage.getItem('restaurantStatus')) {
      return (localStorage.getItem('restaurantStatus') == 'ONLINE' ? true : false);
    } else {
      return true;
    }
  }

  onSummaryClick() {
    this.isSummaryShow = true
  }

  getCurrentUser() {
    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
  }

  getAllFranchises() {
    this.adminService.getFranchises().subscribe((res) => {
      this.franchises = res.data;
    })
    $('#spicker_franchise').selectpicker('refresh');
    $('#spicker_franchise').selectpicker('val');
  }

  getTenants() {
    if (this.authService.getLoggedUser() != null) {
      this.adminService.getOutlets().subscribe((res) => {
        this.shops = res.data;
        if (this.loggedUserRole > 2) {
          $("#spicker_shop").removeAttr("disabled");
        }
      })

    }

  }

  async selectFranchise(e) {

    this.counterVar = this.counterVar + 1;

    //check value pass from dashboard as well
    if (this.counterVar > 1 && this.fromDashBoard) {
      await this.adminService.getShopsRelatedFranchise(e)
        .subscribe({
          next: (res) => {
            this.shops = res.data;
          },
          error: (error) => console.log(error)
        })

      setTimeout(function () {
        $("#spicker_shop").removeAttr("disabled");
        $('#spicker_shop').selectpicker('refresh');
        $('#spicker_shop').selectpicker('val', '')

      }, 1);
    } else if (!this.fromDashBoard) {
      await this.adminService.getShopsRelatedFranchise(e)
        .subscribe({
          next: (res) => {

            this.shops = res.data;
          },
          error: (error) => console.log(error)
        })
      setTimeout(function () {
        $("#spicker_shop").removeAttr("disabled");
        $('#spicker_shop').selectpicker('refresh');
        $('#spicker_shop').selectpicker('val', '')

      }, 1);
    }

  }

  selectShop(e) {

    this.counterVar = this.counterVar + 1;
    //check value pass from dashboard as well
    if (this.counterVar > 2 && this.fromDashBoard) {
      if (e != null) {
        this.adminService.getShop(e)
          .subscribe({
            next: (res) => {
              this.selectedOutletCode = res.data.code;
              this.selectedFilterShop = res.data.id;
              this.outletCodes = [];
              this.outletCodes.push(this.selectedOutletCode);
              this.getDashbaordData(this.startDate, this.endDate);
              this.isDataLoaded = false;
            },
            error: (error) => this.isDataLoaded = false

          })


      }
    } else if (!this.fromDashBoard) {
      if (e != null) {
        this.adminService.getShop(e)
          .subscribe({
            next: (res) => {

              this.selectedOutletCode = res.data.code;
              this.selectedFilterShop = res.data.id;
              this.outletCodes = [];
              this.outletCodes.push(this.selectedOutletCode);
              this.getDashbaordData(this.startDate, this.endDate);
              this.isDataLoaded = false;

            },
            error: (error) => this.isDataLoaded = false
          })


      }
    }
  }

  loadFilters() {

    if (!this.isFilterClicked) {
      this.isFilterClicked = true;

    } else {
      this.isFilterClicked = false;
    }
    //check dashboard value available if not load the franchises as usual 
    if (this.fromDashBoard) {
      this.setFilters();
    } else {
      $('#spicker_franchise').selectpicker('refresh');
      $('#spicker_franchise').selectpicker('val');
      $('#spicker_shop').selectpicker('refresh');
    }


  }

  setFilters() {

    let selectedFranchise = [];
    let tmpselectedFranchise = [];

    let selectedShops = [];
    let tmpselectedShops = [];

    tmpselectedFranchise.push(parseInt(this.selectedFilterFranchise));

    (this.franchises).forEach((value, index) => {
      if (tmpselectedFranchise.includes(value.id)) {
        // console.log('truwe');
        selectedFranchise.push(index + ': ' + value.id);
      }
    });

    this.filterForm.patchValue({
      franchise: tmpselectedFranchise
    });

    tmpselectedShops.push(parseInt(this.selectedFilterShop));

    (this.shops).forEach((value, index1) => {
      if (tmpselectedShops.includes(value.id)) {
        selectedShops.push(index1 + ': ' + value.id);
      }
    });

    this.filterForm.patchValue({
      shop: tmpselectedShops
    });

    $('#spicker_franchise').selectpicker('refresh');
    $('#spicker_franchise').selectpicker('val', selectedFranchise);

    $("#spicker_shop").removeAttr("disabled");
    $('#spicker_shop').selectpicker('refresh');
    $('#spicker_shop').selectpicker('val', selectedShops)
  }
  onClickBack() {
    this.router.navigate(['/home']);
  }
}
